<template>
    <div :class="{ retrieve: true, appRetrieve: flag == 'app' }">
        <!-- <div class="header">
            <span class="fl">新时代家谱</span>
            <a href="javascript:;" class="fr">立即登录</a>
        </div> -->
        <div id="admin">
            <!-- v-loading="loading" -->
            <div class="pos">
                <h1 class="adminh1">找回密码</h1>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="手机号：" prop="pass">
                        <el-input prefix-icon="el-icon-user" :class="{ appWidth:flag == 'app' }"  style="width: 250px" type="text" v-model="ruleForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机验证码：" prop="mCode">
                        <el-input prefix-icon="el-icon-menu" :class="{ appWidth1:flag == 'app' }"  style="width: 115px" type="text" v-model="ruleForm.mCode" autocomplete="off"></el-input>
                        <el-button type="primary"  @click="getCode()" style="margin-left: 10px">{{ codeMsg }}</el-button>
                    </el-form-item>
                    <el-form-item label="创建密码：" prop="checkPass" style="margin-top: 30px;">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 250px"
                            :class="{ appWidth:flag == 'app' }" 
                            show-password
                            type="password"
                            v-model="ruleForm.checkPass"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="password" style="margin-top: 30px;">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 250px"
                            :class="{ appWidth:flag == 'app' }" 
                            show-password
                            type="password"
                            v-model="ruleForm.password"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-input prefix-icon="el-icon-menu" :class="{ appWidth1:flag == 'app' }"  style="width: 115px" type="text" v-model="ruleForm.code" autocomplete="off"></el-input>
                        <img :src="forgetpassscr" alt="" @click="captcha('forgetpass')" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">找回密码</el-button>
                        <el-button @click="login()">返回登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-dialog title="手机短信验证码" :visible.sync="dialogVisible" :width="flag=='pc'?'30%':'100%'">
            <span>
                <el-input prefix-icon="el-icon-menu" style="width: 115px" type="text" v-model="mobileCode" autocomplete="off"></el-input>
                <img :src="forgetTempCodescr" alt="" @click="captcha('forgetTempCode')" style="vertical-align: top" />
            </span>
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="getCode()">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import api from "@/request/api";
export default {
    name: "forgetpass",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输手机号"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value.length < 8) {
                callback(new Error('密码长度至少8位'));
            } else if (value.length > 20) {
                callback(new Error('密码长度不能超过20位'));
            } else if (!/[a-zA-Z]/.test(value)) {
                callback(new Error('密码必须包含字母'));
            } else if (!/[0-9]/.test(value)) {
                callback(new Error('密码必须包含数字'));
            } else{
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            forgetTempCodescr: "",
            forgetpassscr: "",
            ruleForm: {
                pass: "",
                checkPass: "",
                code: "",

                mobile: "",
                password: "",
                msgcode: ""
            },
            rules: {
                pass: [{ validator: validatePass, trigger: "blur" }],
                checkPass: [{ validator: validatePass2, trigger: "blur" }],
                code: [{ validator: validateCode, trigger: "blur" }],
            },
            countdown: 60,
            //按钮上的文字
            codeMsg: "获取验证码",
            mobileCode: "",
            //定时器
            timer: null,
            dialogVisible: false,
            flag: "pc"

        };
    },
    mounted() {
        this.flag = sessionStorage.getItem("flag");
        this.captcha("forgetpass");
    },
    methods: {
        // register() {
        //     api.register(
        //         JSON.stringify({
        //             mobile: this.mobile,
        //             password: this.password,
        //             code: this.code,
        //             msgcode: this.msgcode,
        //             familyName: this.familyName,
        //             givenName: this.givenName
        //         })
        //     ).then((res) => {
        //         console.log(res);
        //     });
        // },
        submitForm(formName) {
            this.loading = true;
            
            api.forgetpass({
                mobile: this.ruleForm.pass,
                password: this.ruleForm.checkPass,
                newpassword: this.ruleForm.password,
                code: this.ruleForm.code,
                msgcode: this.ruleForm.mCode
            }).then((res) => {
                this.loading = false;
                if (res.code == 0) {
                    this.$message({
                        message: "找回成功",
                        type: "success"
                    });
                    setTimeout(() => {
                        this.$router.push("/");
                        this.loading = false;
                    }, 1000);
                } else {
                    this.captcha();
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        },
        captcha(type) {
            api.captcha(type).then((res) => {
                this[type + "scr"] = res.data;
            });
        },
        // 获取手机验证码
        getMobileCode() {
            if (this.ruleForm.pass != "") {
                !this.timer ? (this.dialogVisible = true) : "";
            } else {
                this.$message({
                    message: "请输入手机号",
                    type: "warning"
                });
            }
        },
        getCode() {
            //alert( this.mobileCode,'-- this.mobileCode')
            if (!this.timer) {
                api.sendmsg({
                    mobile: this.ruleForm.pass,
                    code: this.mobileCode,
                    type: 2
                }).then((res) => {
                    if (res.code == 0) {
                        this.setTime();
                        this.$message({
                            message: "发送成功",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            }
        },
        //倒计时
        setTime() {
            let _this = this;
            this.timer = setInterval(() => {
                if (_this.countdown > 0 && _this.countdown <= 60) {
                    _this.countdown--;
                    if (_this.countdown !== 0) {
                        _this.codeMsg = "重新发送(" + _this.countdown + ")";
                    } else {
                        clearInterval(_this.timer);
                        _this.codeMsg = "获取验证码";
                        _this.countdown = 60;
                        _this.timer = null;
                    }
                }
            }, 1000);
        },
        login() {
            this.$router.push("/");
        }
        
    },
    components: {}
};
</script>
<style lang="less">
.retrieve {
    width: 100%;
    height: 100%;
    background: url("../assets/img/bj_zhuce.jpg");
    .header {
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
    }

    #admin {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -200px;
        margin-left: -250px;
        width: 400px;
        height: auto;
        min-height: 400px;
        background: #fff;
        border-radius: 15px;
        border: 1px solid #f3f3f3;
    }
    .adminh1 {
        margin: 10px;
        font-size: 20px;
    }
}
.appRetrieve {
    #admin {
        width: 90% !important;
        margin: 0 !important;
        left: 5% !important;
        transform: translateY(-50%) !important;
        .appWidth{
            width:90% !important;
        }
        .appWidth1{
            width:41% !important; 
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve.vue